<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h1 id="header-text">Create Industry Scenario</h1>
</div>

<mat-stepper labelPosition="bottom" linear="true" class="stepper" #stepper>
  <mat-step [completed]="firstForm.form.valid">
    <ng-template matStepLabel>Enter Information</ng-template>
    <form #firstForm="ngForm">

      <div class="equal-flex-container extra-space">
        <span class="equal-flex-item">
          <mat-form-field>
            <mat-label>Scenario Name</mat-label>
            <input matInput #scenarioNameInput name="scenarioName" required [maxlength]="scenarioNameMaxLength"
                   [(ngModel)]="scenarioName">
            <mat-hint align="start">{{ scenarioNameInput.value.length }}/{{ scenarioNameMaxLength }}
              Characters</mat-hint>
          </mat-form-field>
        </span>
        <span class="equal-flex-item">
          <mat-form-field>
            <mat-label>Scenario Category</mat-label>
            <mat-select name="selectedCategory" required [(ngModel)]="selectedCategory">
              <mat-option *ngFor="let category of scenarioCategories" [value]="category">{{ category }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="equal-flex-item">
          <mat-form-field>
            <mat-label>Scenario Type</mat-label>
            <mat-select name="selectedType" required [(ngModel)]="selectedType">
              <mat-option *ngFor="let type of scenarioTypes" [value]="type">{{ type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>

      <mat-form-field>
        <mat-label>Scenario Assumption</mat-label>
        <input matInput #assmInput name="assm" required [maxLength]="assumptionMaxLength"
               [(ngModel)]="scenarioAssumptions">
        <mat-hint align="start">{{ assmInput.value.length }}/{{ assumptionMaxLength }} Characters</mat-hint>
      </mat-form-field>
    </form>
    <div class="footer">
      <button [disabled]="!firstForm.form.valid" matStepperNext mat-flat-button color="primary" class="action-button"
              id="first-step-button">
        Next
      </button>
    </div>
  </mat-step>

  <mat-step [completed]="checkInputs()">
    <ng-template matStepLabel>Select Source</ng-template>
    <form #secondForm="ngForm">
      <div class="equal-flex-container">
      <span class="equal-flex-item">
        <mat-form-field>
          <mat-label>Select Source</mat-label>
          <mat-select [(ngModel)]="selectedSource" (selectionChange)="onSourceChange()" name="selectedSource">
            <mat-option *ngFor="let source of sourceList" [value]="source">{{ source }}</mat-option>
          </mat-select>
        </mat-form-field>
      </span>

        <span class="equal-flex-item">
        <mat-form-field *ngIf="selectedSource === fromTemplate">
          <mat-label>Forecast Organization</mat-label>
          <mat-select (selectionChange)="onFcorgFilterChange()" [(ngModel)]="selectedFcorg" name="selectedFcorg"
                      [disabled]="selectedSource === fromGlobal">
            <mat-option *ngFor="let name of fcorgs" [value]="name">
              {{ name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
      </div>
      <div *ngIf="selectedSource === fromTemplate && selectedFcorg !== null" class="form-group">
        <div class="drag-and-drop-container">
          <h4>
            <span class="create-scenario">Please Select File to select worksheets from. </span> (Required Format: .xls
            or
            .xlsx)
          </h4>
        </div>
        <div (files)="upload($event)" *ngIf="!files.length" appDrag class="dropzone">
          <div class="text-wrapper">
            <div class="centered">Drag and Drop Files Here</div>
            <p class="centered">or</p>
            <p class="centered">{{ file?.name }}</p>
            <div [hidden]="file?.name.length > 0">
              <app-upload-button (eventEmitter)="upload($event)" [apiUrl]="excelService.excelSheetUrl"
                                 class="upload centered app-upload-button">

              </app-upload-button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedSource === fromGlobal" class="w-100 content-height">
        <app-global-scenario-select-component
          [user]="stateService.getUserGmid()"
          [filterNonGM]="true"
          [memberScenarioType]="1"
          (confirmEvent)="onSelectGlobal($event)">
        </app-global-scenario-select-component>
      </div>

      <!-- Table container-->
      <div *ngIf="selectedSource === fromScenario" class="content-height">
        <app-industry-scenario-select
          [isMultiSelect]="false"
          titleText="Select Industry Scenario"
          (confirmEvent)="onSelect($event)">
        </app-industry-scenario-select>
      </div>
    </form>

    <div class="footer">
      <button mat-stroked-button class="action-button" matStepperPrevious>Back</button>
      <button mat-flat-button class="action-button" [disabled]="!checkInputs()" matStepperNext color="primary"
              id="second-step-button">Next
      </button>
    </div>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Confirm</ng-template>
    <ng-template matStepContent>
      <mat-action-list class="stepper-list" *ngIf="checkInputs">
        <mat-list-item (click)="updateScenarioName(scenarioName,scenarioNameMaxLength)"
                       (keydown)="updateScenarioName(scenarioName, scenarioNameMaxLength)">
          <span matListItemTitle>Scenario Name
            <mat-icon class="confirm-icons">create</mat-icon>
          </span>
          <span matListItemLine>{{ scenarioName }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item (click)="stepper.previous(); stepper.previous();"
                       (keydown)="stepper.previous(); stepper.previous();">
          <span matListItemTitle>Scenario Category
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
          </span>
          <span matListItemLine>{{ selectedCategory }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item (click)="stepper.previous(); stepper.previous();"
                       (keydown)="stepper.previous(); stepper.previous();">
          <span matListItemTitle>Scenario Type
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
          </span>
          <span matListItemLine>{{ selectedType }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item (click)="updateAssumption(scenarioAssumptions,assumptionMaxLength)"
                       (keydown)="updateAssumption(scenarioAssumptions,assumptionMaxLength)">
          <span matListItemTitle>Assumption
            <mat-icon class="confirm-icons">create</mat-icon>
          </span>
          <span matListItemLine>{{ scenarioAssumptions }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
          <span matListItemTitle>Base Scenario Source
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
          </span>
          <span matListItemLine>{{ selectedSource }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
        <div *ngIf="selectedSource === fromScenario">
          <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
            <span matListItemTitle>Selected Industry Scenario
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
            </span>
            <span matListItemLine>{{ selectedIndustryScenario?.industryScenarioName }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>
        <div *ngIf="selectedSource === fromGlobal">
          <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
            <span matListItemTitle>Industry Scenarios
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
            </span>
            <span matListItemLine *ngFor="let scenario of selectedMemberScenarios">{{ scenario.id }}
              | {{ scenario.forecastOrganization }}
              | {{ scenario.industryScenarioName }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>
        <div *ngIf="selectedSource === fromTemplate">
          <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
            <span matListItemTitle>Sheets
            <mat-icon class="confirm-icons">chevron_left</mat-icon>
            </span>
            <span matListItemLine *ngFor="let sheet of sheets.selectedOptions">{{ sheet }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>
        <mat-list-item (click)="stepper.previous()" (keydown)="stepper.previous()">
          <span matListItemTitle>Forecast Organization
          <mat-icon class="confirm-icons">chevron_left</mat-icon>
          </span>
          <span matListItemLine>{{ selectedFcorg }}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
      </mat-action-list>
      <div class="footer">
        <button mat-stroked-button matStepperPrevious class="action-button">Back</button>
        <button mat-flat-button color="primary" matStepperNext class="action-button" id="create-button"
                (click)="createIndustryScenario()">
          Create
        </button>
      </div>
    </ng-template>
  </mat-step>
</mat-stepper>
